import React from 'react';
import { Users, UserCheck, UserX, Clock } from 'lucide-react';

/**
 * AttendanceStats - Display attendance statistics cards
 * @param {Object} stats - Statistics object
 * @param {number} stats.totalCheckedIn - Total checked in students
 * @param {number} stats.present - Present count
 * @param {number} stats.absent - Absent count
 * @param {number} stats.late - Late count
 * @param {boolean} isLoading - Loading state
 */
const AttendanceStats = ({ stats, isLoading = false }) => {
  const { totalCheckedIn = 0, present = 0, absent = 0, late = 0 } = stats || {};

  const statCards = [
    {
      label: 'Total Checked In',
      value: totalCheckedIn,
      icon: Users,
      color: 'purple',
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-600',
      borderColor: 'border-purple-100',
    },
    {
      label: 'Present Today',
      value: present,
      icon: UserCheck,
      color: 'green',
      bgColor: 'bg-green-50',
      textColor: 'text-green-600',
      borderColor: 'border-green-100',
    },
    {
      label: 'Absent Today',
      value: absent,
      icon: UserX,
      color: 'red',
      bgColor: 'bg-red-50',
      textColor: 'text-red-600',
      borderColor: 'border-red-100',
    },
    {
      label: 'Late Today',
      value: late,
      icon: Clock,
      color: 'yellow',
      bgColor: 'bg-yellow-50',
      textColor: 'text-yellow-600',
      borderColor: 'border-yellow-100',
    },
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 animate-pulse">
            <div className="h-8 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statCards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.label}
            className={`bg-white rounded-xl p-4 shadow-sm border ${card.borderColor} hover:shadow-md transition-shadow`}
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">{card.label}</p>
                <p className={`text-2xl font-bold ${card.textColor}`}>
                  {card.value}
                </p>
              </div>
              <div className={`${card.bgColor} p-2 rounded-lg`}>
                <Icon size={20} className={card.textColor} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AttendanceStats;
